const { Ray, ray } = require('./dist/web.cjs');

module.exports = { Ray, ray };
